var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFarmapolisColorCollapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_farmapolis_color_collapsed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 64,
    viewBox: "0 0 106 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    width: 106,
    height: 64,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3853",
    "data-name": "Grupo 3853",
    transform: "translate(16 19.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2364",
    "data-name": "Trazado 2364",
    d: "M298.328,274.478l17.911-22.751a6.71,6.71,0,0,1,4.476-2.608l29.05.014-18.115,22.752a5.689,5.689,0,0,1-4.541,2.606Z",
    transform: "translate(-275.297 -249.098)",
    fill: "#ff5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2365",
    "data-name": "Trazado 2365",
    d: "M334.38,274.5l-17.891-22.769a6.705,6.705,0,0,0-4.473-2.611l-29.051-.014,18.094,22.769a5.688,5.688,0,0,0,4.538,2.609Z",
    transform: "translate(-282.965 -249.105)",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2366",
    "data-name": "Trazado 2366",
    d: "M326.74,272.031l-28.408-.017,14.187-18.033Z",
    transform: "translate(-275.296 -246.635)",
    fill: "#ff274c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFarmapolisColorCollapsed);
export default __webpack_public_path__ + "static/media/ic_farmapolis_color_collapsed.3abc999cd0d20b22aefcd47931e9feab.svg";
export { ForwardRef as ReactComponent };